import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory, } from "react-router-dom";
import Box from "../../../components/_styles/Box";
import { Card } from "../../../styles";
import Table from "../../../components/Table/Table";
import { ReactComponent as EmptyStateImg } from "../../../assets/empty-state-search.svg";
import DoubleDataCell from "../PatientList/LastScanCell";
import { EmptyState } from "../../../components/EmptyState/EmptyState";
import { useDispatch, useSelector } from "react-redux";
import RemoveConfirmation from "../ReportCohort/RemoveConfirmation";
import LoadMoreButton from "../../../components/LoadMoreButton";
import {
  deleteReportSetting,
  getComputedReport,
} from "../../../actions/radminSettings";
import EditReportSetting from "./EditReportSetting";
import { Button, makeStyles } from "@material-ui/core";

export const Image = styled.img`
  width: 20px;
  margin-right: 7px;
  color: #000000;
  fill: #000000;
`;
const HeaderLabel = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #0c2945;
  font-family: Roboto Condensed;
  margin-bottom: 12px;
`;

const useStyles = makeStyles({
  label: {
    padding: "5px 0px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  campaignButton: {
    backgroundColor: "#00AEEF",
    textTransform: "none",
    width: "8rem",
    height: "38px",
    color: "#FFFFFF",
    border: "2px solid #00AEEF",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#00AEEF",
    },
  },
});



const ReportSettings = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState();
  const [isUpdateReport, setIsUpdateReport] = useState(false);
  const [page, setPage] = useState(1);
  const [isLoadingDeleteReport, setIsLoadingDeleteReport] = useState(false);

  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const createPermission = rolePermissions
    ?.find((itm) => itm.name === "Cohorts")
    ?.permissions.find((itm) => itm.codename === "add_cohorts")?.is_authorized;
  const deletePermission = rolePermissions
    ?.find((itm) => itm.name === "Cohorts")
    ?.permissions.find((itm) => itm.codename === "delete_cohorts")
    ?.is_authorized;
  const updatePermission = rolePermissions
    .find((itm) => itm.name === "Cohorts")
    ?.permissions.find((itm) => itm.codename === "change_cohorts")
    ?.is_authorized;

  const updateUrlPath = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("id");
    url.searchParams.delete("action");
    window.history.pushState({}, "", url.toString());
  };

  const computedReportsData = useSelector(
    (state) => state.radAdmin.computedReports
  );



  const columns = [
  {
    key: "name",
    name: "Setting Name",
    align: "left",
    displayCell: (cellValue, rowData) => cellValue ?? "-",
  },

  {
    key: "computed_status_filter",
    name: "Computed Status",
    align: "left",
    displayCell: (cellValue, rowData) =>
      cellValue
        ?.map((itm) =>
          itm.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
        )
        ?.join(", ") ?? "-",
  },

  {
    key: "cohorts",
    name: "Cohorts Title",
    align: "left",
    displayCell: (cellValue, rowData) => {
      if (!cellValue?.length) return "-";

      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {cellValue.map((data) => (
            <span
              key={data?.id}
              onClick={()=> data.title && history.push(`/auth/radAdmin/followUp/reports/cohorts/details/${data?.id}`, {
                data: data
              })}
              style={{ color: "#1890ff", textDecoration: "underline", cursor:'pointer' }}
            >
              {data.title}
            </span>
          ))}
        </div>
      );
    },
  },

  {
    key: "days",
    name: "Days",
    align: "left",
  },
  {
    key: "modality_mappings",
    name: "Modality Mappings",
    align: "left",
    displayCell: (cellValue, rowData) =>
      cellValue?.map((data, index) => {
        return (
          <div key={index}>
            Initial Modality: {data.report2_modality}, Subsequent Modality:{" "}
            {data.subsequent_modality}
          </div>
        );
      }),
  },
  {
    key: "exam_code_mappings",
    name: "Exam Code Mappings",
    align: "left",
    displayCell: (cellValue, rowData) =>
      cellValue?.map((data, index) => {
        return (
          <div key={index}>
            Initial Exam Code: {data.report2_exam_code}, Subsequent Exam Code:{" "}
            {data.subsequent_exam_code}
          </div>
        );
      }),
  },
];

  const dialogHandler = (data) => {
    setRemoveDialogOpen(!removeDialogOpen);
    setSelectedId(data.id);
    window.analytics.track("Report-Setting-Delete-Button-Click");
  };

  const deleteReportHandler = () => {
    setIsLoadingDeleteReport(true);
    dispatch(deleteReportSetting(selectedId)).then((res) => {
      if (res) {
        setPage(1);
        setIsLoadingDeleteReport(false);
        setRemoveDialogOpen(false);
        setSelectedId();
        setIsUpdateReport(false);
        updateUrlPath();
      }
    });
  };

  const onLoadMore = () => {
    dispatch(getComputedReport(page + 1));
    setPage(page + 1);
  };

  useEffect(() => {
   const query = new URLSearchParams(history.location.search);
   const id = query.get("id");
    dispatch(getComputedReport(page, id));
  }, []);

  useEffect(() => {
  const query = new URLSearchParams(history.location.search);
  const id = query.get("id");
  const action = query.get("action");

  const shouldUpdate = Boolean(id || action);
  setIsUpdateReport(shouldUpdate);
}, [history.location.search]);

  const onClickBackButton = () => {
    setIsUpdateReport(false);
    setPage(1);
    dispatch(getComputedReport(1));
    updateUrlPath();
  };

  return (
    <Box>
      <RemoveConfirmation
        content="Are you sure you want to remove report setting?"
        openDialog={removeDialogOpen}
        dialogHandler={dialogHandler}
        isLoading={isLoadingDeleteReport}
        deleteHandler={deleteReportHandler}
        heading={"Remove Report Setting"}
        removeHeader={"Yes, Remove Report Setting"}
      />
      <HeaderLabel> Report Settings Status</HeaderLabel>
      {isUpdateReport ? (
        <EditReportSetting
          onClickBackButton={onClickBackButton}
          dialogHandler={dialogHandler}
        />
      ) : (
        <>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button
              classes={{ label: classes.label, root: classes.campaignButton }}
              onClick={() => {
                history.push(
                        `/auth/radAdmin/settings?type=report-settings-status&action=create`,
                      );
                      setIsUpdateReport(true);
              }}
            >
              Create Report Setting
            </Button>
          </div>
          <Card>
            <Table
              rows={computedReportsData?.data && computedReportsData?.data}
              columns={columns.concat({
                key: "2",
                name: "",
                align: "right",
                displayCell: (cellValue, rowData) => (
                  <DoubleDataCell
                    mainInfo={"edit"}
                    EditRecoHandler={() => {
                      history.push(
                        `/auth/radAdmin/settings?type=report-settings-status&id=${rowData?.id}`,
                        { data: rowData }
                      );
                      window.analytics.track(
                        "Report-Settings-Edit-Button-Click"
                      );
                      setIsUpdateReport(true);
                      setSelectedData(rowData);
                    }}
                    RemoveRecoHandler={() => dialogHandler(rowData)}
                  />
                ),
              })}
              isLoadingRows={
                computedReportsData.isLoading
                && page < 2
              }
              getRowsAction={(page) => getComputedReport(page)}
              totalItems={computedReportsData.totalItems}
              initialPageNumber={computedReportsData.pageNumber}
              noDataRender={() => (
                <EmptyState title={"No Results"} img={() => <EmptyStateImg />}>
                  Sorry, there are no results
                </EmptyState>
              )}
            />
            {computedReportsData?.data &&
              computedReportsData?.data.length !== 0 && (
                <LoadMoreButton
                  title="Load more"
                  isLoading={
                    computedReportsData?.isLoading &&
                    computedReportsData?.totalItems !==
                      computedReportsData?.data.length
                  }
                  handleClick={onLoadMore}
                  isDisabled={
                    computedReportsData?.totalItems ===
                    computedReportsData?.data.length
                  }
                />
              )}
          </Card>
        </>
      )}
    </Box>
  );
};

export default ReportSettings;
